/**
 * design-tools/tokens.js
 * Digital Billions Group — v2 Design Token System
 */

export const PALETTE = {
  // Primary teal scale
  teal50:  '#99e2b4',
  teal100: '#88d4ab',
  teal200: '#78c6a3',
  teal300: '#67b99a',
  teal400: '#56ab91',
  teal500: '#469d89',
  teal600: '#358f80',
  teal700: '#248277',
  teal800: '#14746f',
  teal900: '#036666',

  // Warm accent — used for featured pricing cards (northeast → southwest texture)
  gold:       '#d4a84b',
  goldMid:    '#b8923a',
  goldDark:   '#7a5c1e',
  goldFaint:  'rgba(212,168,75,0.12)',
  goldBorder: 'rgba(212,168,75,0.35)',

  // Dark surfaces
  ink:       '#0a1210',
  inkDeep:   '#060e0c',
  inkMid:    '#162820',
  inkSoft:   '#1f3a2e',
  bgAlt:     '#0d1a18',
  bgSurface: '#0f1f1a',
  bgCard:    '#112418',
  bgElevated:'#162820',

  // Diagram / readable ink — lighter so visible on dark bg
  diagramInk:  '#3a7a6e',
  diagramFaint:'#2a5a52',

  border:       'rgba(53, 143, 128, 0.18)',
  borderBright: 'rgba(102, 213, 197, 0.28)',

  // Light text scale
  white:     '#f0faf7',
  whiteMid:  'rgba(240,250,247,0.78)',
  whiteSoft: 'rgba(240,250,247,0.58)',
  whiteMuted:'rgba(240,250,247,0.38)',
  whiteFaint:'rgba(240,250,247,0.15)',

  // Glow
  glow:      '#36c4a8',
  glowFaint: 'rgba(54,196,168,0.12)',
};

export const GLOW = {
  teal:       '0 0 20px rgba(54,196,168,0.35), 0 0 60px rgba(54,196,168,0.1)',
  tealStrong: '0 0 30px rgba(54,196,168,0.55), 0 0 80px rgba(54,196,168,0.2)',
  tealSoft:   '0 0 12px rgba(54,196,168,0.2)',
  gold:       '0 0 24px rgba(212,168,75,0.35), 0 0 60px rgba(212,168,75,0.12)',
  goldStrong: '0 0 32px rgba(212,168,75,0.5), 0 0 80px rgba(212,168,75,0.18)',
  card:       '0 4px 32px rgba(0,0,0,0.5), 0 1px 0 rgba(54,196,168,0.12)',
  cardHover:  '0 8px 48px rgba(0,0,0,0.6), 0 0 24px rgba(54,196,168,0.18)',
  text:       '0 0 16px rgba(54,196,168,0.45)',
  goldText:   '0 0 16px rgba(212,168,75,0.5)',
};

export const SHADOW = {
  sm:  '0 2px 8px rgba(0,0,0,0.4)',
  md:  '0 4px 24px rgba(0,0,0,0.5)',
  lg:  '0 8px 48px rgba(0,0,0,0.6)',
  xl:  '0 16px 80px rgba(0,0,0,0.7)',
};

export const MOTION = {
  fast:     '0.35s',
  medium:   '0.75s',
  slow:     '1.2s',
  cinematic:'2s',
  ease:     'cubic-bezier(0.16, 1, 0.3, 1)',
  easeIn:   'cubic-bezier(0.4, 0, 1, 1)',
  easeOut:  'cubic-bezier(0, 0, 0.2, 1)',
};

export const GLASS = {
  surface: {
    background: 'rgba(13, 31, 25, 0.7)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(53, 143, 128, 0.18)',
  },
};
